import PropTypes from "prop-types";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { createAdTargeting } from "../utils/createAdTargeting";
import buildPlaceDimensions from "../udo/buildPlaceDimensions";

function createMarkup(utag = {}) {
  return `
    window.lp = window.lp || {};
    window.lp.ads = window.lp.ads || ${JSON.stringify(createAdTargeting(utag))}
    window.lp.analytics = window.lp.analytics || {};
    window.lp.analytics.dataLayer = [${JSON.stringify(utag)}];
    ${process.env.NODE_ENV !== "production" ? `window.lp.analytics.send = function(options) {
      const dataLayer = JSON.stringify(window.lp.analytics.dataLayer[0], null, 2);
      console.group("GTM");
      console.info(dataLayer);
      console.info(options);
      console.groupEnd("GTM");
    }` : ""}
    window.dataLayer = window.lp.analytics.dataLayer;
    `;
}

export class UniversalDataTag extends React.Component {
  componentWillReceiveProps() {
    Object.assign(window.lp.ads, createAdTargeting(this.props.udo), {
      layers: this.adLayers(),
    });
  }

  adLayers() {
    const networkId = 9885583;

    return [networkId, "LonelyPlanet.com", "Destinations", this.props.udo.content_group_2];
  }

  /* eslint-disable */
  render() {
    return (
      <div className="UniversalDataTag">
        <Helmet
          titleTemplate="%s - Lonely Planet"
          script={[{
            name: "udo",
            type: "text/javascript",
            innerHTML: createMarkup(this.props.udo)
          }]}
        />
      </div>
    );
  }
  /* eslint-enable */
}

UniversalDataTag.propTypes = {
  udo: PropTypes.objectOf(Object),
};

const getPoi = (state) => state.pois.initial;
const getListPoi = (state) => (state.list.items.length && state.list.items[0]);
const getUdo = (state) => state.udo;
const getPlace = (state) => state.place;

const getUdoComputed = createSelector(
  [
    getPoi,
    getListPoi,
    getUdo,
    getPlace,
  ], (poi, listPoi, udo, place) => {
  const computedUdo = {};
  let placeUdo = {};

  if (listPoi) {
    computedUdo.poiType = listPoi.poiType;

    if (listPoi.subtypes) {
      computedUdo.subtypes = listPoi.subtypes.join(",");
    }

    placeUdo = buildPlaceDimensions(place);
  }

  if (poi) {
    computedUdo.poiName = poi.name;
    computedUdo.poiType = poi.poiType;
    computedUdo.poi_atlas_id = poi.id;

    if (poi.subtypes) {
      computedUdo.subtypes = poi.subtypes.join(",");
    }

    placeUdo = buildPlaceDimensions(poi.containingPlace);
  }

  return Object.assign({}, placeUdo, computedUdo, udo);
});

const mapStateToProps = (state) => ({
  place: state.place,
  udo: getUdoComputed(state),
  list: state.list.items,
});

const connected = connect(mapStateToProps)(UniversalDataTag);
export { connected };


// WEBPACK FOOTER //
// ./assets/shared/components/universalDataTag.jsx